<template>
  <v-skeleton-loader
    :loading="isLoading"
    transition="expand-transition"
    type="article"
  >
    <FormBrand
      :Brand="editBrand"
      :isSaving="isSaving"
      @save="save"
      @cancel="$router.push({name: from.name })" />
  </v-skeleton-loader>
</template>

<script>
import { mapActions, mapState } from 'vuex';
import loading from '@codehq/aurora-app-core/src/mixins/loading';
import FormBrand from '../components/FormBrand.vue';

export default {
  components: {
    FormBrand,
  },
  name: 'EditBrand',
  module: 'Products',
  mixins: [loading],
  meta: {
    breadcrumb:
      [{
        text: 'menu.home',
        to: { name: 'app-Home' },
      }, {
        text: 'menu.brands',
        to: { name: 'products-ListBrand' },
      }, {
        text: 'menu.edit',
        to: { name: 'products-EditBrand' },
        disabled: true,
      },
      ],
  },
  data() {
    return {
      /**
      * Get/Set editing Brand. Default to {}.
      */
      editBrand: {},
      /**
       * Query Id for Brand
       */
      brandId: this.$route?.query.id,
    };
  },
  computed: {
    /** Vuex states
     */
    ...mapState('brands', ['brands', 'brand']),
    /** Get the mode for this view, create or update
     */
    mode() {
      if (this.brandId) {
        return 'edit';
      }
      return 'add';
    },
  },
  async mounted() {
    this.isLoading = true;
    if (this.mode === 'edit') {
      await this.LOAD_brand(this.brandId);
      this.editBrand = this.brand;
    }
    this.isLoading = false;
  },
  methods: {
    /** Vuex methods
     */
    ...mapActions('brands', ['LOAD_brand', 'CREATE_brand', 'UPDATE_brand']),
    /** Method used to save the item
     */
    async save(brand) {
      this.isSaving = true;
      if (this.mode === 'add') {
        await this.CREATE_brand(brand);
      } else {
        await this.UPDATE_brand(brand);
      }
      this.isSaving = false;
      this.$router.push({ name: 'products-ListBrand' });
    },
  },
};
</script>

<docs>
# EditBrand example

'''js
<EditBrand :Brand="Brand" />
'''
</docs>
